import { Fragment } from 'react';
import GroupedUsersSelect from './GroupedUsersSelect';
import CustomizedMenus from 'components/common/CustomSelect/index';
import { delegationDisclaimers } from '../DelegationSection/constants';
import styles from '../styles.scss';
import SelectDataSource from 'pages/delegationOfAuthority/v2/components/SelectDataSource';
export default function UserSection({
    studyTeamMembersNotDelegates,
    isUserNotStudyMember,
    notStudyTeamMembersNotDelegates,
    handleUserSelected,
    dataSources,
    handleCreateDataSource,
    studyAccess,
    handleSelectedStudyAccess,
    handleSelectedDataSource,
    selectedStudyAccess,
    useGroupedSelect,
    selectedUser,
    canAddDataSource,
    errors,
    selectedDataSource,
    canManageUsers,
    complion4FlagEnabled,
}) {
    const { user: userError, dataSource: dataSourceError, studyAccess: studyAccessError } = errors;
    const ErrorComponent = (props) => <p className={styles.errorMessage}>{props.text} is required</p>;
    return (
        <Fragment>
            <GroupedUsersSelect
                label="Select User"
                placeholder="Select User"
                studyTeam={studyTeamMembersNotDelegates}
                notStudyTeam={notStudyTeamMembersNotDelegates}
                isRequired={true}
                useGroupedSelect={useGroupedSelect}
                selectedValue={selectedUser}
                handleUserSelected={handleUserSelected}
                notValid={userError}
                canManageUsers={canManageUsers}
            />
            {userError && (<ErrorComponent text='User' />)}
            {
                (isUserNotStudyMember && useGroupedSelect) && (
                    <Fragment>
                        <SelectDataSource
                            label="Data Source"
                            placeholder="Data Source"
                            dataSources={dataSources}
                            isRequired={true}
                            buttonLabel={'Create'}
                            handleSelectedDataSource={handleSelectedDataSource}
                            handleCreateDataSource={handleCreateDataSource}
                            canAddDataSource={canAddDataSource}
                            selectedDataSource={selectedDataSource}
                            dataSourceError={dataSourceError}
                            errors={errors}
                            delegationDisclaimers={delegationDisclaimers}
                        />
                        { dataSourceError && (<ErrorComponent text='Data source' />)}
                        <CustomizedMenus
                            label= {complion4FlagEnabled ? 'Binder Access' : 'Study Access'}
                            placeholder={complion4FlagEnabled ? 'Select Binder Access' : 'Select Study Access'}
                            options={studyAccess}
                            isRequired={true}
                            value={selectedStudyAccess.label}
                            onSelectedOption={handleSelectedStudyAccess}
                            isSearchable={false}
                            notValid={studyAccessError}
                        />
                        {studyAccessError && (<ErrorComponent text={complion4FlagEnabled ? 'Binder Access' : 'Study Access'} />)}
                        
                    </Fragment>
                )
            }
        </Fragment>
    );
}